import { render, staticRenderFns } from "./Intro-body.vue?vue&type=template&id=86f2a464"
import script from "./Intro-body.vue?vue&type=script&lang=js"
export * from "./Intro-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports